import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class MagiisGeoCodeServiceCommand extends IRequestCommand<
  IMagiisGeoCodeServiceResponse,
  ErrorDetails,
  IMagiisGeoCodeServiceCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'places/getPlace?';

  public override setParameters(parameters: IMagiisGeoCodeServiceCommandParameters) {
    this._commandUrl = parameters.placeId ? this._commandUrl.concat('placeId=' + parameters.placeId.toString()) : this._commandUrl.concat('');
    this._commandUrl = parameters.coords ? this._commandUrl.concat('latitude=' + parameters.coords.lat.toString()) : this._commandUrl.concat('');
    this._commandUrl = parameters.coords ? this._commandUrl.concat('&longitude=' + parameters.coords.lng.toString()) : this._commandUrl.concat('');
    this._commandUrl = parameters.address ? this._commandUrl.concat('address=' + parameters.address.toString()) : this._commandUrl.concat('');
  }
}

export interface IMagiisGeoCodeServiceCommandParameters
  extends ICommandParameters {
    placeId?: string;
    coords?: {lat: number, lng: number};
    address?: string;
  }

export interface IMagiisGeoCodeServiceResponse
  extends ICommandResponse {}
